import React, { useContext } from "react";
import pptpage from "../Energyanalysis_Bus/CESL_Energy_Analytics_Navigation_Guide.pdf"
import DashboardMain_Bus from "../DashboardMain_Bus/DashboardMain_Bus";

function PPTPage_Energy_Bus() {
  return (
    <>
      <DashboardMain_Bus>
        <iframe src={pptpage} frameborder="0" height="539em" width="100%" sandbox></iframe>
      </DashboardMain_Bus>
    </>
  );
}

export default PPTPage_Energy_Bus;